<template>
   <div class="editMap">
        <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
            <el-tab-pane label="会员客单数" name="kds">
              <div class="kds"></div>
            </el-tab-pane>
            <el-tab-pane label="会员客数" name="kdj">
              <div class="kdj"></div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import req from "@/request.js";
export default {
  name: "EditMapYy",
  data() {
    return {
      fdbh:0,
      activeName: 'kds',
      conheight: { height: (window.innerHeight-42)  + "px",width:"100%"},
    };
  },
  methods: {
    handleClick(tab, event) {
      $(".kds").html("");
      $(".kdj").html("");
      let ERP_DEPT = JSON.parse(sessionStorage.getItem("ERP_DEPT"));
      if(ERP_DEPT.length>=0){
        if(tab.name == "kds") {//客单数
          $(".kds").append('<iframe src="static/editMap_kds.html" scrolling="no" style="width:100%;height:'+(window.innerHeight-42)+"px"+'" frameborder="0"></iframe>');
        }

        if(tab.name == "kdj") {//客单数
          $(".kdj").append('<iframe src="static/editMap_kdj.html" scrolling="no" style="width:100%;height:'+(window.innerHeight-42)+"px"+'" frameborder="0"></iframe>');
        }
      }
    }
  },
  mounted(){
    let this_ = this;
    let sql = "SELECT B.SHOPDM,B.WLDPDM,A.HTH, COUNT(DISTINCT A.HYID) KS, SUM(A.XFCS) KDS, nvl(ROUND(SUM(A.XSJE)/10000,2),0) HYXSJE, b.zt FROM (SELECT DISTINCT A.YEARMONTH,C.HTH,A.HYID,A.XSJE,A.XFCS FROM CR_HYK_XFMX_YHZ@TOCRM A  LEFT JOIN SHSPXX@TOCRM B ON (A.SBID=B.SHSBID) LEFT JOIN SHHT@TOCRM C ON (B.SHHTID=C.SHHTID)WHERE A.YEARMONTH=to_char(add_months(sysdate,-2),'yyyymm') AND A.MDID=201 ) A LEFT JOIN V_PUWEIGL@bfbhdd8 B ON (A.HTH=B.HTH) WHERE B.SHOPDM IS NOT NULL AND B.FDBH=201 GROUP BY B.SHOPDM,B.WLDPDM,A.HTH,b.zt";
    req.post(window.context.bpmRunTime + "/bpm/haiyaScript/executeSql?param="+Base64.encode(sql)).then(resp=>{
      sessionStorage.setItem("ERP_KD",JSON.stringify(resp.data.result));
      sessionStorage.setItem("netUrl_kd",window.context.bpmRunTime)
    });
    let User = JSON.parse(window.sessionStorage.currentUser);
    req.post(window.context.bpmRunTime + "/bpm/haiyaScript/executeSql?param="+Base64.encode('select a.floor,a.fdbh from ERP_JGZX@BFBHDD8 a where a.rydm="+User.account +"order by a.floor desc')).then(resp=>{
      if(resp.data.result.length>=0){
        sessionStorage.setItem("ERP_DEPT",JSON.stringify(resp.data.result));
        this_.fdbh = resp.data.result[0].FDBH;//后续门店上线需按门店区分入口，现阶段按楼层分
        $(".kds").append('<iframe src="static/editMap_kds.html" scrolling="no" style="width:100%;height:'+(window.innerHeight-42)+"px"+'" frameborder="0"></iframe>');
      }
    });

    
  },
};
</script>


<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";

/deep/ .el-tabs__header{
  margin: 0px !important;
  padding-top: 0px !important;
  text-align: center !important;
  border: 0px !important;
}

/deep/ .el-tabs--border-card{
  border: 0px !important;
}

/deep/ .el-tabs__active-bar{
  display: none !important;
}

/deep/ .el-tabs__nav{
  width: 100% !important;
}

/deep/ .el-tabs__content{
  padding: 0px !important;
}
</style>